<template>
  <div class="row">
    <div class="col-sm-1">
      <i class="item-icon me-3" :class="getFileIcon()"></i>
    </div>
    <div class="col-sm-3">
      <h5>
        <a href="#" class="" @click="openFilePreviewDialog()">
          {{ file.fileName }}
        </a>
        <span class="badge bg-secondary" v-if="file.downloads !== 0">{{
          file.downloads
        }}</span>
      </h5>
    </div>
    <div class="col-sm-2">
      {{ $moment(file.createdAt).format("DD/MM/YYYY") }}
    </div>
    <div class="col-sm-2">{{ file.category.value }}</div>
    <div class="col-sm-2">{{ file.tag ? file.tag.value : "" }}</div>
    <div class="col-sm-2 col-action">
      <div class="row">
        <div class="col">
          <i class="far fa-arrow-alt-circle-down" @click="downloadFile()"></i>
        </div>
        <div class="col">
          <i
            class="fas fa-external-link-alt"
            @click="generateTemporaryUrl()"
          ></i>
        </div>
        <div class="col">
          <i class="fas fa-edit" @click="openEditFileDialog()"></i>
        </div>
        <div class="col" v-if="role !== 'utente'">
          <i class="far fa-trash-alt" @click="deleteFile()"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FilesService from "@/services/files";
import TemporaryUrlSerivice from "@/services/temporary-url";
import JSZip from "jszip";
import JSZipUtils from "jszip-utils";
import { saveAs } from "file-saver";
import { mapGetters } from "vuex";

export default {
  props: ["file"],
  computed: {
    ...mapGetters("currentUser", ["role"]),
  },
  methods: {
    async deleteFile() {
      const conf = confirm("Sei sicuro di voler eliminare questo documento?");

      if (conf === true) {
        await FilesService.deleteFile(this.$db, this.file.uuid);

        this.$emit("deleted", true);
      }
    },

    async downloadFile() {
      const zip = new JSZip();
      const url = this.file.url;
      const _this = this;

      this.$toast.info("Generazione link di download in corso...");

      JSZipUtils.getBinaryContent(url, async function (err, data) {
        if (err) {
          this.$toast.error("Impossibile scaricare questo file.");
          throw err;
        }

        await FilesService.updateDownloadsCounter(_this.$db, _this.file.uuid);

        zip.file(`${_this.file.fileName}.${_this.file.ext}`, data, {
          binary: true,
        });

        const content = await zip.generateAsync({ type: "blob" });

        saveAs(content, `${_this.file.fileName}.zip`);
      });
    },

    getFileIcon() {
      switch (this.file.fileType.value.toLowerCase()) {
        case "immagini": {
          return "far fa-image";
        }
        case "documenti": {
          return "fas fa-folder";
        }
        case "video": {
          return "fas fa-film";
        }
        case "audio": {
          return "far fa-file-audio";
        }
        default: {
          return "fas fa-folder";
        }
      }
    },

    openFilePreviewDialog() {
      this.$emit("preview", this.file);
    },

    openEditFileDialog() {
      this.$emit("edit", this.file);
    },

    openThumbnailDialog(url) {
      this.$emit("thumbnail", url);
    },

    async generateTemporaryUrl() {
      this.$toast.info("Generazione url di condivisione in corso...");

      const url = await this.getTemporaryFileUrl();

      if (!url) {
        const payload = {
          fileName: this.file.fileName,
          fileType: this.file.fileType,
          fileUuid: this.file.uuid,
          url: this.file.url,
        };

        await TemporaryUrlSerivice.addTemporaryUrl(this.$db, payload);

        const url = await this.getTemporaryFileUrl();

        await this.copyToClipboard(url);
      } else {
        await this.copyToClipboard(url);
      }
    },

    async copyToClipboard(url) {
      const temporaryUrl = `${window.location.protocol}//${window.location.host}/file-preview/${url.uuid}`;
      await navigator.clipboard.writeText(temporaryUrl);

      this.$toast.success("Link di condivisione copiato!");
    },

    async getTemporaryFileUrl() {
      const { docs } = await TemporaryUrlSerivice.getTemporaryUrlByFileUuid(
        this.$db,
        this.file.uuid
      );
      const urls = docs.map((doc) => doc.data());

      return urls[0];
    },
  },
};
</script>

<style lang="scss" scoped>
.col i {
  cursor: pointer;
}

.file-thumbnail {
  width: 40px;
  height: 40px;
  margin-right: 10px;
  object-fit: cover;
  border-radius: 50%;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/FileCard.vue